export var CommonServiceIds;
(function (CommonServiceIds) {
    CommonServiceIds.DesignerHost = 'DesignerHost';
    CommonServiceIds.ContextMenu = 'ContextMenu';
    CommonServiceIds.Selection = 'Selection';
    CommonServiceIds.GxmlNodeFactory = 'GxmlNodeFactory';
    CommonServiceIds.InteropCommandResolver = 'InteropCommandResolver';
    CommonServiceIds.InteropContextMenu = 'InteropContextMenu';
    CommonServiceIds.InteropContextMenuResolver = 'InteropContextMenuResolver';
    CommonServiceIds.InteropKeybinding = 'InteropKeybinding';
    CommonServiceIds.InteropSelection = 'InteropSelection';
    CommonServiceIds.InteropModel = 'InteropModel';
    CommonServiceIds.InteropDragDrop = 'InteropDragDrop';
    CommonServiceIds.InteropSettings = 'InteropSettings';
})(CommonServiceIds || (CommonServiceIds = {}));
//# sourceMappingURL=common-services-ids.js.map